import React from 'react';
import { FaFacebookF, FaLinkedinIn, FaYoutube, FaInstagram } from 'react-icons/fa';

const Footer = () => (
  <footer className="py-5 border-top  bg-white text-dark">
    <div className="container">
      <div className="row">
        {/* Left Section - Social & Copyright */}
        <div className="col-md-6 d-flex flex-column justify-content-between mb-4 mb-md-0">
          <div className="mb-3 d-flex gap-3">
            <a href="https://www.facebook.com/share/1JKURCEs6e/" target="_blank"><FaFacebookF size={20} className="text-secondary" /></a>
            <a href="https://in.linkedin.com/" target="_blank"><FaLinkedinIn size={20} className="text-secondary" /></a>
            <a href="https://www.youtube.com/@ProspectPulse-b9n" target="_blank"><FaYoutube size={20} className="text-secondary" /></a>
            <a href="https://www.instagram.com/prospectpulse2025?igsh=dnFiMTZiOGlkb2xh" target="_blank"><FaInstagram size={20} className="text-secondary" /></a>
          </div>
          <p className="mb-0">&copy; 2025 Nurturix. All rights reserved.</p>
        </div>

        {/* Right Section - Links */}
        <div className="col-md-6 d-flex justify-content-md-end gap-5">
          <div>
            <h6 className="fw-bold mb-3">Learn more about us</h6>
            <ul className="list-unstyled text-secondary">
              <li><a href="#" className="text-secondary text-decoration-none">Values</a></li>
              <li><a href="/products" className="text-secondary text-decoration-none">Product</a></li>
              <li><a href="#" className="text-secondary text-decoration-none">Offices</a></li>
              <li><a href="/privacy-policy" className="text-secondary text-decoration-none">Privacy Policy</a></li>
              <li><a href="/cookie-settings" className="text-secondary text-decoration-none">Cookie Settings</a></li>
              <li><a href="/terms-and-conditions" className="text-secondary text-decoration-none">Terms & Conditions</a></li>
              <li><a href="/zoom-integration-guide" className="text-secondary text-decoration-none">Zoom Integration Guide</a></li>
            </ul>
          </div>
          <div>
            <h6 className="fw-bold mb-3">Product</h6>
            <ul className="list-unstyled text-secondary">
              <li><a href="#" className="text-secondary text-decoration-none">Leads Management</a></li>
              <li><a href="#" className="text-secondary text-decoration-none">Pulse Web Studio</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
